import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-700.css';
import '@cub-com-br/theme/styles/fonts.css';
import '@cub-com-br/theme/styles/tokens.css';
import { cubTheme } from '@cub-com-br/theme';
import { tokens } from '@cub-com-br/theme/tokens';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './api/query-client';
import { App } from './app';
import './styles.scss';

const theme = createTheme(cubTheme, {
  typography: {
    h1: { ...cubTheme.typography.h1, fontFamily: tokens.fontBody },
    h2: { ...cubTheme.typography.h2, fontFamily: tokens.fontBody },
    h3: { ...cubTheme.typography.h3, fontFamily: tokens.fontBody },
    button: { ...cubTheme.typography.button, fontFamily: tokens.fontBody },
  },
});

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </ThemeProvider>,
);
